const itemCount = {
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: 'normal'
}

const loyaltyProductsGrid = {
  itemCount
}

export default loyaltyProductsGrid
